import classNames from 'classnames';
import PropTypes from 'prop-types';
import type * as React from 'react';

export { GridItem } from './GridItem';
export type { Props as GridItemProps, Resolution, Size } from './GridItem';

Grid.propTypes = {
    children: PropTypes.node,
    noPadding: PropTypes.bool,
    verticalAlign: PropTypes.oneOf(['top', 'center', 'bottom', 'baseline']),
    horizontalAlign: PropTypes.oneOf(['right', 'center']),
};

export interface Props {
    children?: React.ReactNode;
    verticalAlign?: 'top' | 'center' | 'bottom' | 'baseline';
    horizontalAlign?: 'right' | 'center';
    noPadding?: boolean;
}

/**
 * @deprecated Please leverage the native CSS grid possibities.
 */
export function Grid({ children, verticalAlign, horizontalAlign, noPadding = false }: Props) {
    const valign = verticalAlign ? `valign--${verticalAlign}` : null;
    const align = horizontalAlign ? `align--${horizontalAlign}` : null;
    const noGutters = noPadding ? 'grid--no_gutters' : null;
    return <div className={classNames('grid', valign, align, noGutters)}>{children}</div>;
}
